import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CustomDateFormatsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>, // oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const customDateFormatsEntryPoint: EntryPoint<CustomDateFormatsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<CustomDateFormatsEntryPointComponent>(
			/* webpackChunkName: "async-custom-date-formats" */ './CustomDateFormatsPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
